import { useState, useCallback, useEffect } from 'react';
import { Modal } from 'antd';
import { FillButton, BranchSearch } from 'components/elements';
import DaumPostCode from 'react-daum-postcode';
import {getLinkedBranchAPI} from 'api/school';


export const AddressLinkedBranchModal = ({ data, setData }) => {
  const [open, setOpen] = useState(false)
  

  const fnComplete = (data) => {
    const { zonecode, address, bcode, area_type } = data;
    fnHandleInfo({hope_area: address, hope_area_zip_code: zonecode, sigungu_cd:bcode, area_type:area_type})
    fnGetLinkedBranch(bcode)
    fnClose()
  }
  const fnClose = () => {
    setOpen(false)
  }

  // 연결지사 idx 받아오기
  const fnGetLinkedBranch = async (sigungu_cd) => {
    const params = {
      sigungu_cd: sigungu_cd
    }
    await getLinkedBranchAPI(params)
    .then(res => {
      const { BRANCH_IDX, AREA_TYPE } = res?.data?.data_info;
      fnHandleInfo({linked_branch_idx: BRANCH_IDX, area_type: AREA_TYPE})
    })
    .catch(err => {
      console.error(err);
    })
  }

  const fnHandleInfo = useCallback((value) => {
    setData(data => ({
      ...data,
      ...value
    }))
  }, []);


  return (<>
    <FillButton label={'주소찾기'} backgroundColor={'var(--color-gray03)'} onClick={() => setOpen(true)} />
    <Modal
      key={open ? 'open' : 'closed'}
      width={550}
      open={open}
      onCancel={fnClose}
      footer={[
        <FillButton label='닫기' onClick={fnClose} />
      ]}
      styles={{
        body: {
          padding: '3rem 1rem 1rem 1rem'
        }
      }}
    >
      <DaumPostCode
        onComplete={fnComplete}
        style={{ height: 600 }}
      />
    </Modal>
  </>)
}
